

    @if(project(); as currentProject) {

            <mce-page-with-navigation>
                <div>
                    <mce-cable-list [project]="currentProject"></mce-cable-list>
                </div>
            </mce-page-with-navigation>
    }





